

export const toTitleCase = (sentence?: string): string =>
  sentence
    ? sentence
        .split('')
        .map((letter, index, arr) => {
          if (!arr[index - 1] || /[\s-_]/.test(arr[index - 1])) {
            return letter.toUpperCase();
          } else if (/[A-Z]/.test(arr[index]) && /[a-z]/.test(arr[index - 1])) {
            return ` ${letter}`;
          } else if (['-', '_'].includes(letter)) {
            return ' ';
          } else {
            return letter.toLowerCase();
          }
        })
        .join('')
        .replace(/\s+/g, ' ') // removes excess whitespace
        .trim()
    : '';

export const snakeToTitleCase = (word?: string): string => {
  return word
    ? word
        .split('_')
        .filter(Boolean)
        .map(w => toTitleCase(w.trim()))
        .join(' ')
    : '';
};
